<style>
tr:hover td {
    background-color: #3F51B5;
}
.yearlyColor {color: #5db0ff !important;}
.relationshipColor {color: #E91E63 !important;}
.yearlyRelationshipColor {color: #9c6aff !important;}
.moneyColor {color: #0f9e3e !important;}
.successColor {color: #fecf4a !important;}
.loveColor {color: #FFA0FF !important;}

</style>
<template>
	<div>
		<!-- BEGIN breadcrumb -->
    <!--
		<ol class="breadcrumb float-xl-end">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item active"><a href="javascript:;">Dashboard</a></li>
		</ol>
		-->
		<!-- END breadcrumb -->
		<!-- BEGIN page-header -->
		<h1 class="page-header mb-3">Report Admin</h1>
		<!-- END page-header -->
		<!-- BEGIN daterange-filter -->
    <!--
    <div class="d-sm-flex align-items-center mb-3">

			<date-range-picker ref="picker" class="btn btn-dark me-2" 
				:opens="dateRange.opens"
				:locale-data="{ firstDay: 1, format: 'DD-MM-YYYY' }"
				:singleDatePicker="dateRange.singleDatePicker"
				:timePicker="dateRange.timePicker"
				:timePicker24Hour="dateRange.timePicker24Hour"
				:showWeekNumbers="dateRange.showWeekNumbers"
				:showDropdowns="dateRange.showDropdowns"
				:autoApply="dateRange.autoApply"
				v-model="dateRange.range"
				@update="updateValues"
				:linkedCalendars="dateRange.linkedCalendars">
					<template v-slot:input="picker">
						<i class="fa fa-calendar fa-fw text-white text-opacity-50 ms-n1"></i>
						{{ picker.startDate | date }} - {{ picker.endDate | date }}
						<b class="caret ms-1 opacity-5"></b>
					</template>
			</date-range-picker>

			<div>Creation Date Filter</div>
      &nbsp;&nbsp;
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" id="usedatefilter" checked />
    </div>
    <div>
    <select class="form-select" style="background:#191d21; color: #ffff00;" v-on:change="changedReportTypeFilter">
      <option selected value="0">All Report Types</option>
      <option value="171">Yearly</option>
      <option value="176">Relationship</option>
      <option value="180">Yearly Relationship</option>
      <option value="181">Find Money</option>
      <option value="182">Find Success</option>
    </select>
    </div>
		</div>
-->
<b-modal id="yearlyedit" size="lg" cancel-variant="default" scrollable no-close-on-backdrop>
  <template slot="modal-header">
    <h4 class="modal-title">Edit Yearly Report</h4>
    <a class="btn-close" @click="$bvModal.hide('yearlyedit')"></a>
  </template>
  <p class="text-center">
    <span v-if="rec.orderno">
      Name: <b style="color: white;">{{rec.display_name}}</b> - Email: <b><a :href="rec.mailto_user_email">{{rec.user_email}}</a></b> - Order No: <b style="color: white;">{{rec.orderno}}</b> - Created: <b style="color: white">{{rec.createdate_formatted}}</b>
    </span>
    <span v-else>
      <b>EMPTY REPORT</b>
    </span>
  </p>
  <form>
  <div v-if="loadingYearlyModal" class="loading text-center"><div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div></div>
  <div v-else>
    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Person's Name</label>
      <div class="col-md-4">
        <input class="form-control mb-5px" placeholder="Name of Person in Report" v-model="rpt.name" value="rpt.name" />
      </div>
      <label class="form-label col-form-label col-md-2 text-end">E-mail</label>
      <div class="col-md-4">
        <input type="text" class="form-control mb-5px" placeholder="Report Email" v-model="rpt.email" value="rpt.email" />
      </div>
    </div>

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Birth Date</label>
      <div class="col-md-4">
        <input type="text" class="form-control mb-5px" placeholder="Birthdate" v-model="rpt.birthdate" value="rpt.birthdate" v-on:change="changedYearlyBirthdate"/>
      </div>
      <label class="form-label col-form-label col-md-2 text-end">Start Date</label>
      <div class="col-md-4">
        <input type="text" class="form-control mb-5px" placeholder="Start Date" v-model="rpt.repstartdate" value="rpt.repstartdate"/>
      </div>
    </div>

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Card 1</label>
      <div class="col-md-4">
        <select class="form-select" id="rpt_card1" v-model="rpt.perssigni1" style="background: #191d21;">
          <option v-for="(item, key) in rptcards" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
      <label class="form-label col-form-label col-md-2 text-end">Card 2</label>
      <div class="col-md-4">
        <select class="form-select" id="rpt_card2" v-model="rpt.perssigni2" style="background: #191d21;">
          <option v-for="(item, key) in rptcards" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
    </div>

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">PR Card 1</label>
      <div class="col-md-4">
        <select class="form-select" id="rpt_prccard1" v-model="rpt.PRCard1" style="background: #191d21;">
          <option v-for="(item, key) in rptcards" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
      <label class="form-label col-form-label col-md-2 text-end">PR Card 2</label>
      <div class="col-md-4">
        <select class="form-select" id="rpt_prccard2" v-model="rpt.PRCard2" style="background: #191d21;">
          <option v-for="(item, key) in rptcards" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
    </div>
  </div>
  <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Decanate</label>
      <div class="col-md-4">
        <select class="form-select" id="rpt_decanate" v-model="rpt.decanate" style="background: #191d21;">
          <option v-for="(item, key) in rptcards" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
  </div>
  </form>
  <template #modal-footer="{ cancel }">
    <div v-if="loadingYearlyModal"></div>
    <div v-else>
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button variant="primary" @click="addReport('yearlyedit');">
        ADD <span class="fa fa-plus"></span>
      </b-button>&nbsp;
      <span v-if="rpt">
        <b-button variant="primary" @click="viewYearly();">
          VIEW <span class="fa fa-file-alt"></span>
        </b-button>&nbsp;
        <b-button variant="primary" @click="saveYearly();">
          SAVE <span class="fa fa-save"></span>
        </b-button>&nbsp;
        <b-button variant="outline-warning" @click="clearReport('yearlyedit');">
          CLEAR <span class="fa fa-file"></span>
        </b-button>&nbsp;
      </span>
      <b-button variant="danger" @click="deleteReport('yearlyedit');">
        DELETE <span class="fa fa-trash"></span>
      </b-button>&nbsp;
      <b-button variant="primary" @click="cancel()">
        CANCEL <span class="fa fa-cancel"></span>
      </b-button>
    </div>
    </template>
</b-modal>

<b-modal id="relationshipedit" size="lg" cancel-variant="default" scrollable no-close-on-backdrop>
  <template slot="modal-header">
    <h4 class="modal-title">Edit Relationship Report</h4>
    <a class="btn-close" @click="$bvModal.hide('relationshipedit')"></a>
  </template>
  <p class="text-center">
    <span v-if="rec.orderno">
      Name: <b style="color: white;">{{rec.display_name}}</b> - Email: <b><a :href="rec.mailto_user_email">{{rec.user_email}}</a></b> - Order No: <b style="color: white;">{{rec.orderno}}</b> - Created: <b style="color: white">{{rec.createdate_formatted}}</b>
    </span>
    <span v-else>
      <b>EMPTY REPORT</b>
    </span>
  </p>
  <form>
  <div v-if="loadingRelationshipModal" class="loading text-center"><div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div></div>
  <div v-else>

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Sender Name</label>
      <div class="col-md-4">
        <input class="form-control mb-5px" placeholder="This field is ignored" v-model="rpt.sender" value="rpt.sender" />
      </div>
      <label class="form-label col-form-label col-md-2 text-end">E-mail</label>
      <div class="col-md-4">
        <input type="text" class="form-control mb-5px" placeholder="Report Email" v-model="rpt.email" value="rpt.email" />
      </div>
    </div>

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Report Type</label>
      <div class="col-md-6">
        <select class="form-select" id="rpt_type" v-model="rpt.reptype" style="background: #191d21;">
          <option v-for="(item, key) in rpttypes" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
    </div>

    <hr />

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Person 1</label>
      <div class="col-md-4">
        <input class="form-control mb-5px" placeholder="Name of Person 1 in Report" v-model="rpt.name1" value="rpt.name1" />
      </div>
      <label class="form-label col-form-label col-md-2 text-end">Gender</label>
      <div class="col-md-3">
        <select class="form-select" id="rpt_sex1" v-model="rpt.sex1" style="background: #191d21;">
          <option v-for="(item, key) in gendertypes" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
    </div>

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Birth Date</label>
      <div class="col-md-4">
        <input type="text" class="form-control mb-5px" placeholder="Birthdate" v-model="rpt.birthdate1" value="rpt.birthdate1" v-on:change="changedRelationshipBirthdate1" />
      </div>
      <label class="form-label col-form-label col-md-2 text-end">Planet</label>
      <div class="col-md-3">
        <select class="form-select" id="rpt_planet1" v-model="rpt.planet1" style="background: #191d21;">
          <option v-for="(item, key) in planetlist" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
    </div>

    <hr />

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Person 2</label>
      <div class="col-md-4">
        <input class="form-control mb-5px" placeholder="Name of Person 2 in Report" v-model="rpt.name2" value="rpt.name2" />
      </div>
      <label class="form-label col-form-label col-md-2 text-end">Gender</label>
      <div class="col-md-3">
        <select class="form-select" id="rpt_sex2" v-model="rpt.sex2" style="background: #191d21;">
          <option v-for="(item, key) in gendertypes" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
    </div>

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Birth Date</label>
      <div class="col-md-4">
        <input type="text" class="form-control mb-5px" placeholder="Birthdate" v-model="rpt.birthdate2" value="rpt.birthdate2" v-on:change="changedRelationshipBirthdate2" />
      </div>
      <label class="form-label col-form-label col-md-2 text-end">Planet</label>
      <div class="col-md-3">
        <select class="form-select" id="rpt_planet2" v-model="rpt.planet2" style="background: #191d21;">
          <option v-for="(item, key) in planetlist" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
    </div>

  </div>
  </form>
  <template #modal-footer="{ cancel }">
    <div v-if="loadingRelationshipModal"></div>
    <div v-else>
      <b-button variant="primary" @click="addReport('relationshipedit');">
        ADD <span class="fa fa-plus"></span>
      </b-button>&nbsp;
      <span v-if="rpt">
        <b-button variant="primary" @click="viewRelationship();">
          VIEW <span class="fa fa-file-alt"></span>
        </b-button>&nbsp;
        <b-button variant="primary" @click="saveRelationship();">
          SAVE <span class="fa fa-save"></span>
        </b-button>&nbsp;
        <b-button variant="outline-warning" @click="clearReport('relationshipedit');">
          CLEAR <span class="fa fa-file"></span>
        </b-button>&nbsp;
      </span>
      <b-button variant="danger" @click="deleteReport('relationshipedit');">
        DELETE <span class="fa fa-trash"></span>
      </b-button>&nbsp;
      <b-button variant="primary" @click="cancel()">
        CANCEL <span class="fa fa-cancel"></span>
      </b-button>
    </div>
    </template>
</b-modal>


<b-modal id="yearlyrelationshipedit" size="lg" cancel-variant="default" scrollable no-close-on-backdrop>
  <template slot="modal-header">
    <h4 class="modal-title">Edit Yearly Relationship Report</h4>
    <a class="btn-close" @click="$bvModal.hide('yearlyrelationshipedit')"></a>
  </template>
  <p class="text-center">
    <span v-if="rec.orderno">
      Name: <b style="color: white;">{{rec.display_name}}</b> - Email: <b><a :href="rec.mailto_user_email">{{rec.user_email}}</a></b> - Order No: <b style="color: white;">{{rec.orderno}}</b> - Created: <b style="color: white">{{rec.createdate_formatted}}</b>
    </span>
    <span v-else>
      <b>EMPTY REPORT</b>
    </span>
  </p>

  <form>
  <div v-if="loadingYearlyRelationshipModal" class="loading text-center"><div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div></div>
  <div v-else>

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Sender Name</label>
      <div class="col-md-4">
        <input class="form-control mb-5px" placeholder="This field is ignored" v-model="rpt.sender" value="rpt.sender" />
      </div>
      <label class="form-label col-form-label col-md-2 text-end">E-mail</label>
      <div class="col-md-4">
        <input type="text" class="form-control mb-5px" placeholder="Report Email" v-model="rpt.email" value="rpt.email" />
      </div>
    </div>

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Start Date</label>
      <div class="col-md-4">
        <input type="text" class="form-control mb-5px" placeholder="Birthdate" v-model="rpt.startdate" value="rpt.startdate"/>
      </div>
    </div>

    <hr />

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">You / Target Person</label>
      <div class="col-md-4">
        <input class="form-control mb-5px" placeholder="Your Name or Target's Name" v-model="rpt.name1" value="rpt.name1" />
      </div>
      <label class="form-label col-form-label col-md-2 text-end">Gender</label>
      <div class="col-md-3">
        <select class="form-select" id="rpt_sex1" v-model="rpt.sex1" style="background: #191d21;">
          <option v-for="(item, key) in gendertypes" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
    </div>

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Birth Date 1</label>
      <div class="col-md-2">
        <input type="text" class="form-control mb-5px" placeholder="Birthdate" v-model="rpt.birthdate1" value="rpt.birthdate1" v-on:change="changedRelationshipBirthdate1" />
      </div>
      <label class="form-label col-form-label col-md-1 text-end">Planet 1</label>
      <div class="col-md-2">
        <select class="form-select" id="rpt_planet1" v-model="rpt.planet1" style="background: #191d21;">
          <option v-for="(item, key) in planetlist" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
      <label class="form-label col-form-label col-md-2 text-end">Decanate</label>
      <div class="col-md-3">
        <select class="form-select" id="rpt_decanate1" v-model="rpt.decanate1" style="background: #191d21;">
          <option v-for="(item, key) in rptcards" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
    </div>

    <hr />

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Person 1</label>
      <div class="col-md-4">
        <input class="form-control mb-5px" placeholder="Person 1 Name" v-model="rpt.name2" value="rpt.name2" />
      </div>
      <label class="form-label col-form-label col-md-2 text-end">Gender</label>
      <div class="col-md-3">
        <select class="form-select" id="rpt_sex2" v-model="rpt.sex2" style="background: #191d21;">
          <option v-for="(item, key) in gendertypes" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
    </div>

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Birth Date</label>
      <div class="col-md-2">
        <input type="text" class="form-control mb-5px" placeholder="Birthdate" v-model="rpt.birthdate2" value="rpt.birthdate2" v-on:change="changedRelationshipBirthdate2"  />
      </div>
      <label class="form-label col-form-label col-md-1 text-end">Planet</label>
      <div class="col-md-2">
        <select class="form-select" id="rpt_planet2" v-model="rpt.planet2" style="background: #191d21;">
          <option v-for="(item, key) in planetlist" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
      <label class="form-label col-form-label col-md-2 text-end">Decanate</label>
      <div class="col-md-3">
        <select class="form-select" id="rpt_decanate2" v-model="rpt.decanate2" style="background: #191d21;">
          <option v-for="(item, key) in rptcards" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
    </div>

    <hr />

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Person 2</label>
      <div class="col-md-4">
        <input class="form-control mb-5px" placeholder="Person 2 Name" v-model="rpt.name3" value="rpt.name3" />
      </div>
      <label class="form-label col-form-label col-md-2 text-end">Gender</label>
      <div class="col-md-3">
        <select class="form-select" id="rpt_sex3" v-model="rpt.sex3" style="background: #191d21;">
          <option v-for="(item, key) in gendertypes" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
    </div>

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Birth Date</label>
      <div class="col-md-2">
        <input type="text" class="form-control mb-5px" placeholder="Birthdate" v-model="rpt.birthdate3" value="rpt.birthdate3"  v-on:change="changedRelationshipBirthdate3" />
      </div>
      <label class="form-label col-form-label col-md-1 text-end">Planet</label>
      <div class="col-md-2">
        <select class="form-select" id="rpt_planet3" v-model="rpt.planet3" style="background: #191d21;">
          <option v-for="(item, key) in planetlist" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
      <label class="form-label col-form-label col-md-2 text-end">Decanate</label>
      <div class="col-md-3">
        <select class="form-select" id="rpt_decanate3" v-model="rpt.decanate3" style="background: #191d21;">
          <option v-for="(item, key) in rptcards" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
    </div>

    <hr />

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Person 3</label>
      <div class="col-md-4">
        <input class="form-control mb-5px" placeholder="Person 3 Name" v-model="rpt.name4" value="rpt.name4" />
      </div>
      <label class="form-label col-form-label col-md-2 text-end">Gender</label>
      <div class="col-md-3">
        <select class="form-select" id="rpt_sex4" v-model="rpt.sex4" style="background: #191d21;">
          <option v-for="(item, key) in gendertypes" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
    </div>

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Birth Date</label>
      <div class="col-md-2">
        <input type="text" class="form-control mb-5px" placeholder="Birthdate" v-model="rpt.birthdate4" value="rpt.birthdate4" v-on:change="changedRelationshipBirthdate4"  />
      </div>
      <label class="form-label col-form-label col-md-1 text-end">Planet</label>
      <div class="col-md-2">
        <select class="form-select" id="rpt_planet4" v-model="rpt.planet4" style="background: #191d21;">
          <option v-for="(item, key) in planetlist" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
      <label class="form-label col-form-label col-md-2 text-end">Decanate</label>
      <div class="col-md-3">
        <select class="form-select" id="rpt_decanate4" v-model="rpt.decanate4" style="background: #191d21;">
          <option v-for="(item, key) in rptcards" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
    </div>

  </div>
  </form>
  <template #modal-footer="{ cancel }">
    <div v-if="loadingYearlyRelationshipModal"></div>
    <div v-else>
      <b-button variant="primary" @click="addReport('yearlyrelationshipedit');">
        ADD <span class="fa fa-plus"></span>
      </b-button>&nbsp;
      <span v-if="rpt">
        <b-button class="viewbutton" variant="primary" @click="viewYearlyRelationship();">
          VIEW <span class="fa fa-file-alt"></span>
        </b-button>&nbsp;
        <b-button class="savebutton"  variant="primary" @click="saveYearlyRelationship();">
          SAVE <span class="fa fa-save"></span>
        </b-button>&nbsp;
        <b-button  class="clearbutton" variant="outline-warning" @click="clearReport('yearlyrelationshipedit');">
          CLEAR <span class="fa fa-file"></span>
        </b-button>&nbsp;
      </span>
      <b-button variant="danger" @click="deleteReport('yearlyrelationshipedit');">
        DELETE <span class="fa fa-trash"></span>
      </b-button>&nbsp;
      <b-button variant="primary" @click="cancel()">
        CANCEL <span class="fa fa-cancel"></span>
      </b-button>
    </div>
    </template>
</b-modal>

<b-modal id="moneyedit" size="lg" cancel-variant="default" scrollable no-close-on-backdrop>
  <template slot="modal-header">
    <h4 class="modal-title">Edit Find Money Report</h4>
    <a class="btn-close" @click="$bvModal.hide('moneyedit')"></a>
  </template>
  <p class="text-center">
    <span v-if="rec.orderno">
      Name: <b style="color: white;">{{rec.display_name}}</b> - Email: <b><a :href="rec.mailto_user_email">{{rec.user_email}}</a></b> - Order No: <b style="color: white;">{{rec.orderno}}</b> - Created: <b style="color: white">{{rec.createdate_formatted}}</b>
    </span>
    <span v-else>
      <b>EMPTY REPORT</b>
    </span>
  </p>

  <form>
  <div v-if="loadingMoneyModal" class="loading text-center"><div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div></div>
  <div v-else>
    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Sender's Name</label>
      <div class="col-md-4">
        <input class="form-control mb-5px" placeholder="Name of Sender" v-model="rpt.sender" value="rpt.name" />
      </div>
      <label class="form-label col-form-label col-md-2 text-end">E-mail</label>
      <div class="col-md-4">
        <input type="text" class="form-control mb-5px" placeholder="Report Email" v-model="rpt.email" value="rpt.email" />
      </div>
    </div>

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Name</label>
      <div class="col-md-4">
        <input class="form-control mb-5px" placeholder="Name of Person for Report" v-model="rpt.name" value="rpt.name" />
      </div>
      <label class="form-label col-form-label col-md-2 text-end">Birth Date</label>
      <div class="col-md-4">
        <input type="text" class="form-control mb-5px" placeholder="Birthdate" v-model="rpt.birthdate" value="rpt.birthdate" v-on:change="changedMoneySuccessBirthdate" />
      </div>
    </div>

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Sun Sign</label>
      <div class="col-md-2">
        <select class="form-select" id="rpt_sunsign" v-model="rpt.sunsign" style="background: #191d21;">
          <option v-for="(item, key) in sunsigns" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
      <label class="form-label col-form-label col-md-2 text-end">Decanate</label>
      <div class="col-md-3">
        <select class="form-select" id="rpt_decanate" v-model="rpt.decanate" style="background: #191d21;">
          <option v-for="(item, key) in rptcards" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
      <label class="form-label col-form-label col-md-1 text-end">Start</label>
      <div class="col-md-2">
        <input type="text" class="form-control mb-5px" placeholder="Start date" v-model="rpt.startdate" value="rpt.startdate"/>
      </div>
    </div>

  </div>
  </form>
  <template #modal-footer="{ cancel }">
    <div v-if="loadingMoneyModal"></div>
    <div v-else>
      <b-button variant="primary" @click="addReport('moneyedit');">
        ADD <span class="fa fa-plus"></span>
      </b-button>&nbsp;
      <span v-if="rpt">
        <b-button variant="primary" @click="viewMoney();">
          VIEW <span class="fa fa-file-alt"></span>
        </b-button>&nbsp;
        <b-button variant="primary" @click="saveMoney();">
          SAVE <span class="fa fa-save"></span>
        </b-button>&nbsp;
        <b-button variant="outline-warning" @click="clearReport('moneyedit');">
          CLEAR <span class="fa fa-file"></span>
        </b-button>&nbsp;
      </span>
      <b-button variant="danger" @click="deleteReport('moneyedit');">
        DELETE <span class="fa fa-trash"></span>
      </b-button>&nbsp;
      <b-button variant="primary" @click="cancel()">
        CANCEL <span class="fa fa-cancel"></span>
      </b-button>
    </div>
    </template>
</b-modal>

<b-modal id="successedit" size="lg" cancel-variant="default" scrollable no-close-on-backdrop>
  <template slot="modal-header">
    <h4 class="modal-title">Edit Find Success Report</h4>
    <a class="btn-close" @click="$bvModal.hide('successedit')"></a>
  </template>
  <p class="text-center">
    <span v-if="rec.orderno">
      Name: <b style="color: white;">{{rec.display_name}}</b> - Email: <b><a :href="rec.mailto_user_email">{{rec.user_email}}</a></b> - Order No: <b style="color: white;">{{rec.orderno}}</b> - Created: <b style="color: white">{{rec.createdate_formatted}}</b>
    </span>
    <span v-else>
      <b>EMPTY REPORT</b>
    </span>
  </p>
  <form>
  <div v-if="loadingSuccessModal" class="loading text-center"><div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div></div>
  <div v-else>
    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Sender's Name</label>
      <div class="col-md-4">
        <input class="form-control mb-5px" placeholder="Name of Sender" v-model="rpt.sender" value="rpt.name" />
      </div>
      <label class="form-label col-form-label col-md-2 text-end">E-mail</label>
      <div class="col-md-4">
        <input type="text" class="form-control mb-5px" placeholder="Report Email" v-model="rpt.email" value="rpt.email" />
      </div>
    </div>

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Name</label>
      <div class="col-md-4">
        <input class="form-control mb-5px" placeholder="Name of Person for Report" v-model="rpt.name" value="rpt.name" />
      </div>
      <label class="form-label col-form-label col-md-2 text-end">Birth Date</label>
      <div class="col-md-4">
        <input type="text" class="form-control mb-5px" placeholder="Birthdate" v-model="rpt.birthdate" value="rpt.birthdate" v-on:change="changedMoneySuccessBirthdate" />
      </div>
    </div>

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Sun Sign</label>
      <div class="col-md-2">
        <select class="form-select" id="rpt_sunsign" v-model="rpt.sunsign" style="background: #191d21;">
          <option v-for="(item, key) in sunsigns" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
      <label class="form-label col-form-label col-md-2 text-end">Decanate</label>
      <div class="col-md-3">
        <select class="form-select" id="rpt_decanate" v-model="rpt.decanate" style="background: #191d21;">
          <option v-for="(item, key) in rptcards" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
      <label class="form-label col-form-label col-md-1 text-end">Start</label>
      <div class="col-md-2">
        <input type="text" class="form-control mb-5px" placeholder="Start date" v-model="rpt.startdate" value="rpt.startdate"/>
      </div>
    </div>

  </div>
  </form>
  <template #modal-footer="{ cancel }">
    <div v-if="loadingSuccessModal"></div>
    <div v-else>
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button variant="primary" @click="addReport('successedit');">
        ADD <span class="fa fa-plus"></span>
      </b-button>&nbsp;
      <b-button variant="primary" @click="viewSuccess();">
        VIEW <span class="fa fa-file-alt"></span>
      </b-button>&nbsp;
      <b-button variant="primary" @click="saveSuccess();">
        SAVE <span class="fa fa-save"></span>
      </b-button>&nbsp;
      <b-button variant="outline-warning" @click="clearReport('successedit');">
        CLEAR <span class="fa fa-file"></span>
      </b-button>&nbsp;
      <b-button variant="danger" @click="deleteReport('successedit');">
        DELETE <span class="fa fa-trash"></span>
      </b-button>&nbsp;
      <b-button variant="primary" @click="cancel()">
        CANCEL <span class="fa fa-cancel"></span>
      </b-button>
    </div>
    </template>
</b-modal>

<b-modal id="loveedit" size="lg" cancel-variant="default" scrollable no-close-on-backdrop>
  <template slot="modal-header">
    <h4 class="modal-title">Edit Find Love Report</h4>
    <a class="btn-close" @click="$bvModal.hide('loveedit')"></a>
  </template>
  <p class="text-center">
    <span v-if="rec.orderno">
      Name: <b style="color: white;">{{rec.display_name}}</b> - Email: <b><a :href="rec.mailto_user_email">{{rec.user_email}}</a></b> - Order No: <b style="color: white;">{{rec.orderno}}</b> - Created: <b style="color: white">{{rec.createdate_formatted}}</b>
    </span>
    <span v-else>
      <b>EMPTY REPORT</b>
    </span>
  </p>
  <form>
  <div v-if="loadingLoveModal" class="loading text-center"><div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div></div>
  <div v-else>
    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Sender's Name</label>
      <div class="col-md-4">
        <input class="form-control mb-5px" placeholder="Name of Sender" v-model="rpt.sender" value="rpt.name" />
      </div>
      <label class="form-label col-form-label col-md-2 text-end">E-mail</label>
      <div class="col-md-4">
        <input type="text" class="form-control mb-5px" placeholder="Report Email" v-model="rpt.email" value="rpt.email" />
      </div>
    </div>

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Name</label>
      <div class="col-md-4">
        <input class="form-control mb-5px" placeholder="Name of Person for Report" v-model="rpt.name" value="rpt.name" />
      </div>
      <label class="form-label col-form-label col-md-2 text-end">Birth Date</label>
      <div class="col-md-4">
        <input type="text" class="form-control mb-5px" placeholder="Birthdate" v-model="rpt.birthdate" value="rpt.birthdate" v-on:change="changedMoneySuccessBirthdate" />
      </div>
    </div>

    <div class="row mb-15px">
      <label class="form-label col-form-label col-md-2 text-end">Sun Sign</label>
      <div class="col-md-2">
        <select class="form-select" id="rpt_sunsign" v-model="rpt.sunsign" style="background: #191d21;">
          <option v-for="(item, key) in sunsigns" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
      <label class="form-label col-form-label col-md-2 text-end">Decanate</label>
      <div class="col-md-3">
        <select class="form-select" id="rpt_decanate" v-model="rpt.decanate" style="background: #191d21;">
          <option v-for="(item, key) in rptcards" :value="key" v-bind:key="key" >
            {{item}}
          </option>
        </select>
      </div>
      <label class="form-label col-form-label col-md-1 text-end">Start</label>
      <div class="col-md-2">
        <input type="text" class="form-control mb-5px" placeholder="Start date" v-model="rpt.startdate" value="rpt.startdate"/>
      </div>
    </div>

  </div>
  </form>
  <template #modal-footer="{ cancel }">
    <div v-if="loadingLoveModal"></div>
    <div v-else>
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button variant="primary" @click="addReport('loveedit');">
        ADD <span class="fa fa-plus"></span>
      </b-button>&nbsp;
      <b-button variant="primary" @click="viewLove();">
        VIEW <span class="fa fa-file-alt"></span>
      </b-button>&nbsp;
      <b-button variant="primary" @click="saveLove();">
        SAVE <span class="fa fa-save"></span>
      </b-button>&nbsp;
      <b-button variant="outline-warning" @click="clearReport('loveedit');">
        CLEAR <span class="fa fa-file"></span>
      </b-button>&nbsp;
      <b-button variant="danger" @click="deleteReport('loveedit');">
        DELETE <span class="fa fa-trash"></span>
      </b-button>&nbsp;
      <b-button variant="primary" @click="cancel()">
        CANCEL <span class="fa fa-cancel"></span>
      </b-button>
    </div>
    </template>
</b-modal>

    <div class="row">
      <div class="col-xl-12">
        <div class="card border-0 mb-3 overflow-hidden bg-gray-800 text-white">
          <div class="card-body">
            <div v-if="loading" class="loading text-center"><div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div></div>
            <vue-good-table
              :columns="columns"
              v-if="rows && rows.length"
                :rows="rows"
              :lineNumbers="false"
              :search-options="{ enabled: true, skipDiacritics: true, placeholder: 'Search Current Table' }"
              :pagination-options="{ enabled: true,  position: 'bottom', perPage: 20, mode: 'pages' }"
              :selectOptions="{
                enabled: false,
                selectOnCheckboxOnly: true,
                selectionInfoClass: 'alert alert-info m-b-0 no-rounded-corner',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
              }"
              :sort-options="{
                enabled: true,
                multipleColumns: true,
                initialSortBy: [{field: 'createdate', type: 'desc'}, {field: 'purchasedate', type: 'desc'}]
              }"
              @on-row-click="onRowClick"
            >
              <div slot="table-actions">
                <button class="btn btn-primary ms-2 fw-bold" @click="fetchReportData">REFRESH <span class="fa fa-refresh"></span></button>
              </div>
              <template slot="table-row" slot-scope="props">
                  {{props.formattedRow[props.column.field]}}
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
		<!-- END daterange-filter -->
		<!-- BEGIN row -->
		<!-- END row -->
	</div>
</template>

<script>
import moment from 'moment';
import AppOptions from '../config/AppOptions.vue';
import axios from 'axios';
import { useCookies } from "vue3-cookies";

export default {
	name: 'dashboard-v3',
  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },
	data() {
		function handleGetDate(minusDate) {
			var d = new Date();
			d = d.setDate(d.getDate() - minusDate);
			return d;
		}
		
		var convertNumberWithCommas = function(x) {
			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		};

    let today = new Date()
        today.setHours(0, 0, 0, 0)
        let todayEnd = new Date()
        todayEnd.setHours(11, 59, 59, 999);

/*

SELECT rid, productid, orderno, SUBSTRING(orderid, 4, 8) AS createdate, purchasedate, wpid, user_login, display_name, user_email
FROM bod_reports
LEFT JOIN wp_users ON bod_reports.wpid = wp_users.ID
WHERE wpid <> 0 AND user_login <> '' AND user_login <> 'admin' AND orderno <> 0
ORDER BY createdate DESC, purchasedate DESC


SELECT thunde9_e7thunders.bod_reports.rid, thunde9_e7thunders.bod_reports.productid, thunde9_e7thunders.bod_reports.orderno, SUBSTRING(thunde9_e7thunders.bod_reports.orderid, 4, 8) AS createdate, thunde9_e7thunders.bod_reports.purchasedate, thunde9_e7thunders.bod_reports.wpid, thunde9_wp901.wpiz_users.user_login, thunde9_wp901.wpiz_users.display_name, thunde9_wp901.wpiz_users.user_email
FROM thunde9_e7thunders.bod_reports
LEFT JOIN thunde9_wp901.wpiz_users ON thunde9_e7thunders.bod_reports.wpid = thunde9_wp901.wpiz_users.ID
WHERE wpid <> 0 AND user_login <> '' AND user_login <> 'admin' AND orderno <> 0
ORDER BY createdate DESC, purchasedate DESC


SELECT thunde9_e7thunders.bod_reports.rid, thunde9_e7thunders.bod_reports.productid, thunde9_e7thunders.bod_reports.orderno, IF(SUBSTRING(thunde9_e7thunders.bod_reports.orderid, 4, 8) = '', NULL, SUBSTRING(thunde9_e7thunders.bod_reports.orderid, 4, 8)) AS createdate, thunde9_e7thunders.bod_reports.purchasedate, thunde9_e7thunders.bod_reports.wpid, thunde9_wp901.wpiz_users.user_login, thunde9_wp901.wpiz_users.display_name, thunde9_wp901.wpiz_users.user_email
FROM thunde9_e7thunders.bod_reports
LEFT JOIN thunde9_wp901.wpiz_users ON thunde9_e7thunders.bod_reports.wpid = thunde9_wp901.wpiz_users.ID
WHERE wpid <> 0 AND user_login <> '' AND user_login <> 'admin'
ORDER BY createdate DESC, purchasedate DESC


ADD stuff with 0 order no

 */

		return  {
      rec: 0,
      rpt: 0,
      rpttypes: {
        "Intimate":"Intimate",
        "Friendship":"Friendship",
        "Business":"Business"
      },
      gendertypes: {
        "M" : "Male",
        "F" : "Female"
      },
      planetlist: {
        "Sun": "Sun",
        "Moon": "Moon",
        "Mercury": "Mercury",
        "Venus": "Venus",
        "Mars": "Mars",
        "Jupiter": "Jupiter",
        "Saturn": "Saturn",
        "Uranus": "Uranus",
        "Neptune": "Neptune",
        "Pluto": "Pluto"
      },
      sunsigns: {
        "Aries":"Aries",
        "Taurus":"Taurus",
        "Gemini":"Gemini",
        "Cancer":"Cancer",
        "Leo":"Leo",
        "Virgo":"Virgo",
        "Libra":"Libra",
        "Scorpio":"Scorpio",
        "Sagittarius":"Sagittarius",
        "Capricorn":"Capricorn",
        "Aquarius":"Aquarius",
        "Pisces":"Pisces"
      },
      sunPlanet: {
          "Aries" : "Mars",
          "Taurus" : "Venus",
          "Gemini" : "Mercury",
          "Cancer" : "Moon",
          "Leo" : "Sun",
          "Virgo" : "Mercury",
          "Libra" : "Venus",
          "Scorpio" : "Pluto",
          "Sagittarius" : "Jupiter",
          "Capricorn" : "Saturn",
          "Aquarius" : "Uranus",
          "Pisces" : "Neptune"
      },
      rptcards: {'0': "🂠 None",
        "1": "🂱 Ace of Hearts",
        "2": "🂲 Two of Hearts",
        "3": "🂳 Three of Hearts",
        "4": "🂴 Four of Hearts",
        "5": "🂵 Five of Hearts",
        "6": "🂶 Six of Hearts",
        "7": "🂷 Seven of Hearts",
        "8": "🂸 Eight of Hearts",
        "9": "🂹 Nine of Hearts",
        "10": "🂺 Ten of Hearts",
        "11": "🂻 Jack of Hearts",
        "12": "🂽 Queen of Hearts",
        "13": "🂾 King of Hearts",
        "14": "🃑 Ace of Clubs",
        "15": "🃒 Two of Clubs",
        "16": "🃓 Three of Clubs",
        "17": "🃔 Four of Clubs",
        "18": "🃕 Five of Clubs",
        "19": "🃖 Six of Clubs",
        "20": "🃗 Seven of Clubs",
        "21": "🃘 Eight of Clubs",
        "22": "🃙 Nine of Clubs",
        "23": "🃚 Ten of Clubs",
        "24": "🃛 Jack of Clubs",
        "25": "🃝 Queen of Clubs",
        "26": "🃞 King of Clubs",
        "27": "🃁 Ace of Diamonds",
        "28": "🃂 Two of Diamonds",
        "29": "🃃 Three of Diamonds",
        "30": "🃄 Four of Diamonds",
        "31": "🃅 Five of Diamonds",
        "32": "🃆 Six of Diamonds",
        "33": "🃇 Seven of Diamonds",
        "34": "🃈 Eight of Diamonds",
        "35": "🃉 Nine of Diamonds",
        "36": "🃊 Ten of Diamonds",
        "37": "🃋 Jack of Diamonds",
        "38": "🃍 Queen of Diamonds",
        "39": "🃎 King of Diamonds",
        "40": "🂡 Ace of Spades",
        "41": "🂢 Two of Spades",
        "42": "🂣 Three of Spades",
        "43": "🂤 Four of Spades",
        "44": "🂥 Five of Spades",
        "45": "🂦 Six of Spades",
        "46": "🂧 Seven of Spades",
        "47": "🂨 Eight of Spades",
        "48": "🂩 Nine of Spades",
        "49": "🂪 Ten of Spades",
        "50": "🂫 Jack of Spades",
        "51": "🂭 Queen of Spades",
        "52": "🂮 King of Spades"
      },
      loading: false,
      loadingYearlyModal: true,
      loadingRelationshipModal: true,
      loadingYearlyRelationshipModal: true,
      loadingMoneyModal: true,
      loadingSuccessModal: true,
      loadingLoveModal: true,
        columns: [{
				label: 'Name',
				field: 'display_name',
				thClass: 'text-nowrap',
				tdClass: 'text-nowrap'
			}, {
				label: 'Email',
				field: 'user_email',
				thClass: 'text-nowrap',
				tdClass: 'text-nowrap'
			}, {
				label: 'Type',
				field: (value) => { return this.getProductName(value) },
				thClass: 'text-nowrap',
				tdClass: this.getProductColor,
//        filterOptions: {
//          enabled: true,
//          placeholder: 'All Report Types',
//          filterDropdownItems: ['Yearly', 'Relationship'],
//          styleClass: 'successcolor'
//        }
			}, {
				label: 'Order No.',
				field: 'orderno',
				thClass: 'text-nowrap',
				tdClass: 'text-nowrap'
			}, {
				label: 'Created',
        field: 'createdate',
        type: 'date',
        dateInputFormat: 'yyyyMMdd',
        dateOutputFormat: 'yyyy-MM-dd',
				thClass: 'text-nowrap',
				tdClass: 'text-nowrap'
			}, {
				label: 'Purchased',
				field: 'purchasedate',
        type: 'date',
        dateInputFormat: 'yyyyMMdd',
        dateOutputFormat: 'yyyy-MM-dd',
				thClass: 'text-nowrap',
				tdClass: 'text-nowrap'
			}],
      rows: null,

			areaChart: {
				rightAlignYAxis: false,
				showControls: false,
				clipEdge: false,
				data: [{
					'key' : 'Yearly Reports',
					'color' : AppOptions.color.cyan, //select DATE(createdate) AS datecreated, count(*) AS numreports from view_reportlist WHERE productid = 171 AND createdate >= 20220101 GROUP BY createdate ORDER BY datecreated  --- SELECT * FROM `view_yearly_chart`
					'values' : [ 
						{ x: handleGetDate(77), y: 13 }, { x: handleGetDate(76), y: 13 },  { x: handleGetDate(75), y: 6  },
						{ x: handleGetDate(73), y: 6  },  { x: handleGetDate(72), y: 6  },  { x: handleGetDate(71), y: 5  },  { x: handleGetDate(70), y: 5  }, 
						{ x: handleGetDate(69), y: 5  },  { x: handleGetDate(68), y: 6  },  { x: handleGetDate(67), y: 7  },  { x: handleGetDate(66), y: 6  }, 
						{ x: handleGetDate(65), y: 9  },  { x: handleGetDate(64), y: 9  },  { x: handleGetDate(63), y: 8  },  { x: handleGetDate(62), y: 10 }, 
						{ x: handleGetDate(61), y: 10 },  { x: handleGetDate(60), y: 10 },  { x: handleGetDate(59), y: 10 },  { x: handleGetDate(58), y: 9  }, 
						{ x: handleGetDate(57), y: 9  },  { x: handleGetDate(56), y: 10 },  { x: handleGetDate(55), y: 9  },  { x: handleGetDate(54), y: 9  }, 
						{ x: handleGetDate(53), y: 8  },  { x: handleGetDate(52), y: 8  },  { x: handleGetDate(51), y: 8  },  { x: handleGetDate(50), y: 8  },
						{ x: handleGetDate(49), y: 8  },  { x: handleGetDate(48), y: 7  },  { x: handleGetDate(47), y: 7  },  { x: handleGetDate(46), y: 6  }, 
						{ x: handleGetDate(45), y: 6  },  { x: handleGetDate(44), y: 6  },  { x: handleGetDate(43), y: 6  },  { x: handleGetDate(42), y: 5  }, 
						{ x: handleGetDate(41), y: 5  },  { x: handleGetDate(40), y: 4  },  { x: handleGetDate(39), y: 4  },  { x: handleGetDate(38), y: 5  }, 
						{ x: handleGetDate(37), y: 5  },  { x: handleGetDate(36), y: 5  },  { x: handleGetDate(35), y: 7  },  { x: handleGetDate(34), y: 7  }, 
						{ x: handleGetDate(33), y: 7  },  { x: handleGetDate(32), y: 10 },  { x: handleGetDate(31), y: 9  },  { x: handleGetDate(30), y: 9  }, 
						{ x: handleGetDate(29), y: 10 },  { x: handleGetDate(28), y: 11 },  { x: handleGetDate(27), y: 11 },  { x: handleGetDate(26), y: 8  }, 
						{ x: handleGetDate(25), y: 8  },  { x: handleGetDate(24), y: 7  },  { x: handleGetDate(23), y: 8  },  { x: handleGetDate(22), y: 9  }, 
						{ x: handleGetDate(21), y: 8  },  { x: handleGetDate(20), y: 9  },  { x: handleGetDate(19), y: 10 },  { x: handleGetDate(18), y: 9  }, 
						{ x: handleGetDate(17), y: 10 },  { x: handleGetDate(16), y: 16 },  { x: handleGetDate(15), y: 17 },  { x: handleGetDate(14), y: 16 }, 
						{ x: handleGetDate(13), y: 17 },  { x: handleGetDate(12), y: 16 },  { x: handleGetDate(11), y: 15 },  { x: handleGetDate(10), y: 14 }, 
						{ x: handleGetDate(9) , y: 24 },  { x: handleGetDate(8) , y: 18 },  { x: handleGetDate(7) , y: 15 },  { x: handleGetDate(6) , y: 14 }, 
						{ x: handleGetDate(5) , y: 16 },  { x: handleGetDate(4) , y: 16 },  { x: handleGetDate(3) , y: 17 },  { x: handleGetDate(2) , y: 7  }, 
						{ x: handleGetDate(1) , y: 7  },  { x: handleGetDate(0) , y: 7  }
					]
				}, {
					'key' : 'Page Views',
					'color' : AppOptions.color.blue,
					'values' : [ 
						{ x: handleGetDate(77), y: 14 },  { x: handleGetDate(76), y: 13 },  { x: handleGetDate(75), y: 15 }, 
						{ x: handleGetDate(73), y: 14 },  { x: handleGetDate(72), y: 13 },  { x: handleGetDate(71), y: 15 },  { x: handleGetDate(70), y: 16 }, 
						{ x: handleGetDate(69), y: 16 },  { x: handleGetDate(68), y: 14 },  { x: handleGetDate(67), y: 14 },  { x: handleGetDate(66), y: 13 }, 
						{ x: handleGetDate(65), y: 12 },  { x: handleGetDate(64), y: 13 },  { x: handleGetDate(63), y: 13 },  { x: handleGetDate(62), y: 15 }, 
						{ x: handleGetDate(61), y: 16 },  { x: handleGetDate(60), y: 16 },  { x: handleGetDate(59), y: 17 },  { x: handleGetDate(58), y: 17 }, 
						{ x: handleGetDate(57), y: 18 },  { x: handleGetDate(56), y: 15 },  { x: handleGetDate(55), y: 15 },  { x: handleGetDate(54), y: 15 }, 
						{ x: handleGetDate(53), y: 19 },  { x: handleGetDate(52), y: 19 },  { x: handleGetDate(51), y: 18 },  { x: handleGetDate(50), y: 18 }, 
						{ x: handleGetDate(49), y: 17 },  { x: handleGetDate(48), y: 16 },  { x: handleGetDate(47), y: 18 },  { x: handleGetDate(46), y: 18 }, 
						{ x: handleGetDate(45), y: 18 },  { x: handleGetDate(44), y: 16 },  { x: handleGetDate(43), y: 14 },  { x: handleGetDate(42), y: 14 }, 
						{ x: handleGetDate(41), y: 13 },  { x: handleGetDate(40), y: 14 },  { x: handleGetDate(39), y: 13 },  { x: handleGetDate(38), y: 10 }, 
						{ x: handleGetDate(37), y: 9  },  { x: handleGetDate(36), y: 10 },  { x: handleGetDate(35), y: 11 },  { x: handleGetDate(34), y: 11 }, 
						{ x: handleGetDate(33), y: 11 },  { x: handleGetDate(32), y: 10 },  { x: handleGetDate(31), y: 9  },  { x: handleGetDate(30), y: 10 }, 
						{ x: handleGetDate(29), y: 13 },  { x: handleGetDate(28), y: 14 },  { x: handleGetDate(27), y: 14 },  { x: handleGetDate(26), y: 13 }, 
						{ x: handleGetDate(25), y: 12 },  { x: handleGetDate(24), y: 11 },  { x: handleGetDate(23), y: 13 },  { x: handleGetDate(22), y: 13 }, 
						{ x: handleGetDate(21), y: 13 },  { x: handleGetDate(20), y: 13 },  { x: handleGetDate(19), y: 14 },  { x: handleGetDate(18), y: 13 }, 
						{ x: handleGetDate(17), y: 13 },  { x: handleGetDate(16), y: 19 },  { x: handleGetDate(15), y: 21 },  { x: handleGetDate(14), y: 22 },
						{ x: handleGetDate(13), y: 25 },  { x: handleGetDate(12), y: 24 },  { x: handleGetDate(11), y: 24 },  { x: handleGetDate(10), y: 22 }, 
						{ x: handleGetDate(9) , y: 16 },  { x: handleGetDate(8) , y: 15 },  { x: handleGetDate(7) , y: 12 },  { x: handleGetDate(6) , y: 12 }, 
						{ x: handleGetDate(5) , y: 15 },  { x: handleGetDate(4) , y: 15 },  { x: handleGetDate(3) , y: 15 },  { x: handleGetDate(2) , y: 18 }, 
						{ x: handleGetDate(2) , y: 18 },  { x: handleGetDate(0) , y: 17 }
					]
				}]
			},
			totalSalesChart: {
				options: {
					chart: {
						type: 'line',
						width: 200,
						height: 36,
						sparkline: {
							enabled: true
						},
						stacked: true
					},
					stroke: {
						curve: 'smooth',
						width: 3
					},
					fill: {
						type: 'gradient',
						gradient: {
							opacityFrom: 1,
							opacityTo: 1,
							colorStops: [{
								offset: 0,
								color: AppOptions.color.blue,
								opacity: 1
							},
							{
								offset: 100,
								color: AppOptions.color.indigo,
								opacity: 1
							}]
						},
					},
					tooltip: {
						theme: 'dark',
						fixed: {
							enabled: false
						},
						x: {
							show: false
						},
						y: {
							title: {
								formatter: function () {
									return '';
								}
							},
							formatter: (value) => { return '$'+ convertNumberWithCommas(value) },
						},
						marker: {
							show: false
						}
					},
					responsive: [{
						breakpoint: 1500,
						options: {
							chart: {
								width: 130
							}
						}
					},{
						breakpoint: 1300,
						options: {
							chart: {
								width: 100
							}
						}
					},{
						breakpoint: 1200,
						options: {
							chart: {
								width: 200
							}
						}
					},{
						breakpoint: 576,
						options: {
							chart: {
								width: 180
							}
						}
					},{
						breakpoint: 400,
						options: {
							chart: {
								width: 120
							}
						}
					}]
				},
				series: [{
					data: [9452.37, 11018.87, 7296.37, 6274.29, 7924.05, 6581.34, 12918.14]
				}]
			},
			conversionRateChart: {
				options: {
					chart: {
						type: 'line',
						width: 160,
						height: 28,
						sparkline: {
							enabled: true
						}
					},
					stroke: {
						curve: 'smooth',
						width: 3
					},
					fill: {
						type: 'gradient',
						gradient: {
							opacityFrom: 1,
							opacityTo: 1,
							colorStops: [{
								offset: 0,
								color: AppOptions.color.red,
								opacity: 1
							},
							{
								offset: 50,
								color: AppOptions.color.orange,
								opacity: 1
							},
							{
								offset: 100,
								color: AppOptions.color.lime,
								opacity: 1
							}]
						},
					},
					labels: ['Jun 23', 'Jun 24', 'Jun 25', 'Jun 26', 'Jun 27', 'Jun 28', 'Jun 29'],
					xaxis: {
						crosshairs: {
							width: 1
						},
					},
					tooltip: {
						theme: 'dark',
						fixed: {
							enabled: false
						},
						x: {
							show: false
						},
						y: {
							title: {
								formatter: function () {
									return '';
								}
							},
							formatter: (value) => { return value + '%' },
						},
						marker: {
							show: false
						}
					},
					responsive: [{
						breakpoint: 1500,
						options: {
							chart: {
								width: 120
							}
						}
					},{
						breakpoint: 1300,
						options: {
							chart: {
								width: 100
							}
						}
					},{
						breakpoint: 1200,
						options: {
							chart: {
								width: 160
							}
						}
					},{
						breakpoint: 900,
						options: {
							chart: {
								width: 120
							}
						}
					},{
						breakpoint: 576,
						options: {
							chart: {
								width: 180
							}
						}
					},{
						breakpoint: 400,
						options: {
							chart: {
								width: 120
							}
						}
					}]
				},
				series: [{
					data: [2.68, 2.93, 2.04, 1.61, 1.88, 1.62, 2.80]
				}]
			},
			storeSessionChart: {
				options: {
					chart: {
						type: 'line',
						width: 160,
						height: 28,
						sparkline: {
							enabled: true
						},
						stacked: false
					},
					stroke: {
						curve: 'smooth',
						width: 3
					},
					fill: {
						type: 'gradient',
						gradient: {
							opacityFrom: 1,
							opacityTo: 1,
							colorStops: [{
								offset: 0,
								color: AppOptions.color.teal,
								opacity: 1
							},
							{
								offset: 50,
								color: AppOptions.color.blue,
								opacity: 1
							},
							{
								offset: 100,
								color: '#5AC8FA',
								opacity: 1
							}]
						},
					},
					labels: ['Jun 23', 'Jun 24', 'Jun 25', 'Jun 26', 'Jun 27', 'Jun 28', 'Jun 29'],
					xaxis: {
						crosshairs: {
							width: 1
						},
					},
					tooltip: {
						theme: 'dark',
						fixed: {
							enabled: false
						},
						x: {
							show: false
						},
						y: {
							title: {
								formatter: function () {
									return '';
								}
							},
							formatter: (value) => { return convertNumberWithCommas(value) },
						},
						marker: {
							show: false
						}
					},
					responsive: [{
						breakpoint: 1500,
						options: {
							chart: {
								width: 120
							}
						}
					},{
						breakpoint: 1300,
						options: {
							chart: {
								width: 100
							}
						}
					},{
						breakpoint: 1200,
						options: {
							chart: {
								width: 160
							}
						}
					},{
						breakpoint: 900,
						options: {
							chart: {
								width: 120
							}
						}
					},{
						breakpoint: 576,
						options: {
							chart: {
								width: 180
							}
						}
					},{
						breakpoint: 400,
						options: {
							chart: {
								width: 120
							}
						}
					}]
				},
				series: [{
					data: [10812, 11393, 7311, 6834, 9612, 11200, 13557]
				}]
			}
		}
	},
	methods: {
    getProductName(rowObj)
    {
      switch (rowObj.productid)
      {
        case 171: return 'Yearly';
        case 176: return 'Relationship';
        case 180: return 'Yearly Relationship';
        case 181: return 'Find Money';
        case 182: return 'Find Success';
        case 183: return 'Find Love';
        default: return rowObj.productid;
      }
    },
    getProductColor(rowObj)
    {
      switch (rowObj.productid)
      {
        case 171: return 'yearlyColor';
        case 176: return 'relationshipColor';
        case 180: return 'yearlyRelationshipColor';
        case 181: return 'moneyColor';
        case 182: return 'successColor';
        case 183: return 'loveColor';
        default: return rowObj.productid;
      }
    },
    fetchReportData()
    {
      this.error = null;
      this.loading = true;

      axios
        .post('https://api.destinycards.com/v1/reportadmin/list')
        .then(response => {
            this.rows = response.data.data;
            this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    fetchYearlyReport(number)
    {
      axios
        .get('https://api.destinycards.com/v1/reportadmin/yearly/' + number)
        .then(response => {
            if (response.data.data === null)
            {
                this.rpt = 0;
                //this.$swal.fire('Empty Report', 'This is an empty report. Currently, it can only be deleted.', 'warning');
            }
            else
            {
              this.rpt = response.data.data;
            }
            this.loadingYearlyModal = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    fetchRelationshipReport(number)
    {
      axios
        .get('https://api.destinycards.com/v1/reportadmin/relationship/' + number)
        .then(response => {
            if (response.data.data === null)
            {
                //this.$swal.fire('Empty Report', 'This is an empty report. Currently, it can only be deleted.', 'warning');
            }
            else
            {
              this.rpt = response.data.data;
            }
            this.loadingRelationshipModal = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    fetchYearlyRelationshipReport(number)
    {
      axios
        .get('https://api.destinycards.com/v1/reportadmin/yearlyrelationship/' + number)
        .then(response => {
            if (response.data.data === null)
            {
                //this.$swal.fire('Empty Report', 'This is an empty report. Currently, it can only be deleted.', 'warning');
            }
            else
            {
              this.rpt = response.data.data;
            }
            this.loadingYearlyRelationshipModal = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    fetchMoneyReport(number)
    {
      axios
        .get('https://api.destinycards.com/v1/reportadmin/money/' + number)
        .then(response => {
            if (response.data.data === null)
            {
                //this.$swal.fire('Empty Report', 'This is an empty report. Currently, it can only be deleted.', 'warning');
            }
            else
            {
              this.rpt = response.data.data;
            }
            this.loadingMoneyModal = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    fetchSuccessReport(number)
    {
      axios
        .get('https://api.destinycards.com/v1/reportadmin/success/' + number)
        .then(response => {
            if (response.data.data === null)
            {
                //this.$swal.fire('Empty Report', 'This is an empty report. Currently, it can only be deleted.', 'warning');
            }
            else
            {
              this.rpt = response.data.data;
            }
            this.loadingSuccessModal = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    fetchLoveReport(number)
    {
      axios
        .get('https://api.destinycards.com/v1/reportadmin/love/' + number)
        .then(response => {
            if (response.data.data === null)
            {
                //this.$swal.fire('Empty Report', 'This is an empty report. Currently, it can only be deleted.', 'warning');
            }
            else
            {
              this.rpt = response.data.data;
            }
            this.loadingLoveModal = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    created() {
       this.fetchReportData();
    },
    addReport(modalid) {
      let report_type = 0;
      let report_text = '';

      switch(modalid)
      {
        case 'yearlyedit' : report_type = 171;
                            report_text = 'yearly'; break;
        case 'relationshipedit' : report_type = 176;
                            report_text = 'relationship'; break;
        case 'yearlyrelationshipedit' : report_type = 180;
                            report_text = 'yearly relationship'; break;
        case 'moneyedit' : report_type = 181;
                            report_text = 'find money'; break;
        case 'successedit' : report_type = 182;
                            report_text = 'find success'; break;
        case 'loveedit' : report_type = 183;
                            report_text = 'find love'; break;
      }
              this.$swal.fire({
                title: 'Are you sure?',
                text: 'This will add a report and allow the user to create another ' + report_text + ' report.',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Add Report',
                cancelButtonText: 'Cancel'
              }).then((result) => {
                if (result.isConfirmed)
                {
                  axios
                    .post('https://api.destinycards.com/v1/reportadmin/addreport',
                        {
                          'wpid': this.rec.wpid,
                          'productid': report_type
                        })
                    .then(response => {
                        if (response.status === 200) {
                          this.$swal.fire('Report Added', 'New report has been added!', 'success');
                          this.$root.$emit("bv::hide::modal", modalid);
                          this.fetchReportData();
                        }
                    })
                    .catch(error => {
                      this.$swal.fire('Error', 'There was an error adding a report. Please hit F12 and copy/paste the error message in the console and email support.', 'error');
                      console.log("ERROR - Copy/Paste Info Below");
                      console.log(error);
                    });
              }});
    },
    clearReport(modalid) {
              console.log(this.rpt);
              this.$swal.fire({
                title: 'Are you sure?',
                text: 'This will clear the report and allow the user to create another.',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Clear Report',
                cancelButtonText: 'Cancel'
              }).then((result) => {
                if (result.isConfirmed)
                {
                  axios
                    .post('https://api.destinycards.com/v1/reportadmin/clearreport',
                        {
                          'rid': this.rec.rid
                        })
                    .then(response => {
                        if (response.status === 200) {
                          this.$swal.fire('Report Cleared', 'This report has been cleared!', 'success');
                          this.$root.$emit("bv::hide::modal", modalid);
                          this.fetchReportData();
                        }
                    })
                    .catch(error => {
                      this.$swal.fire('Error', 'There was an error clearing this report. Please hit F12 and copy/paste the error message in the console and email support.', 'error');
                      console.log("ERROR - Copy/Paste Info Below");
                      console.log(error);
                    });
              }});
    },
    deleteReport(modalid) {
              this.$swal.fire({
                title: 'Are you sure?',
                text: 'This will DELETE the report and the user will not be able to create another one.',
                type: 'danger',
                showCancelButton: true,
                confirmButtonText: 'Delete Report',
                cancelButtonText: 'Cancel'
              }).then((result) => {
                if (result.isConfirmed)
                {
                  axios
                    .post('https://api.destinycards.com/v1/reportadmin/deletereport',
                        {
                          'rid': this.rec.rid, 'number': this.rpt.number, 'report_type': this.rpt.productid
                        })
                    .then(response => {
                        if (response.status === 200) {
                          this.$swal.fire('Report Deleted', 'This report has been deleted!', 'success');
                          this.$root.$emit("bv::hide::modal", modalid);
                          this.fetchReportData();
                        }
                    })
                    .catch(error => {
                      this.$swal.fire('Error', 'There was an error deleting this report. Please hit F12 and copy/paste the error message in the console and email support.', 'error');
                      console.log("ERROR - Copy/Paste Info Below");
                      console.log(error);
                    });
              }});
    },
    viewYearly() {
      window.open('https://destinyreports.com/m/yearly.html?no=' + this.rpt.number + '&s=' + this.rpt.orderid, '_blank');
    },
    viewRelationship() {
      window.open('https://destinyreports.com/m/relationship.html?no=' + this.rpt.number + '&s=' + this.rpt.orderid, '_blank');
    },
    viewYearlyRelationship() {
      window.open('https://destinyreports.com/m/yearlyrelationship.html?no=' + this.rpt.number + '&s=' + this.rpt.orderid, '_blank');
    },
    viewMoney() {
      window.open('https://destinyreports.com/m/findmoney.html?no=' + this.rpt.number + '&s=' + this.rpt.orderid, '_blank');
    },
    viewSuccess() {
      window.open('https://destinyreports.com/m/findsuccess.html?no=' + this.rpt.number + '&s=' + this.rpt.orderid, '_blank');
    },
    viewLove() {
      window.open('https://destinyreports.com/m/findlove.html?no=' + this.rpt.number + '&s=' + this.rpt.orderid, '_blank');
    },
    saveYearly() {
      this.loadingYearlyModal = true;

      axios
        .post('https://api.destinycards.com/v1/reportadmin/yearlyupdate', this.rpt)
        .then(response => {
            if (response.status === 200) {
              this.$root.$emit("bv::hide::modal", "yearlyedit");

              this.$swal.fire('Record Saved', 'Report Saved Successfully.<br /><br /><a href="https://www.destinyreports.com/m/yearly.html?no=' + this.rpt.number + '&s=' + this.rpt.orderid + '" target="_blank" style="color: royalblue">View Report</a>', 'success');
              this.loadingYearlyModal = false;
            }
        })
        .catch(error => {
          this.loadingYearlyModal = false;
          this.$swal.fire('Error', 'There was an error saving. Please hit F12 and copy/paste the error message in the console and email support.', 'error');
          console.log("ERROR - Copy/Paste Info Below");
          console.log(error);
        });
    },
    saveRelationship() {
      this.loadingRelationshipModal = true;

      axios
        .post('https://api.destinycards.com/v1/reportadmin/relationshipupdate', this.rpt)
        .then(response => {
            if (response.status === 200) {
              this.$root.$emit("bv::hide::modal", "relationshipedit");

              this.$swal.fire('Record Saved', 'Report Saved Successfully.<br /><br /><a href="https://www.destinyreports.com/m/relationship.html?no=' + this.rpt.number + '&s=' + this.rpt.orderid + '" target="_blank" style="color: royalblue">View Report</a>', 'success');
              this.loadingRelationshipModal = false;
            }
        })
        .catch(error => {
          this.loadingRelationshipModal = false;
          this.$swal.fire('Error', 'There was an error saving. Please hit F12 and copy/paste the error message in the console and email support.', 'error');
          console.log("ERROR - Copy/Paste Info Below");
          console.log(error);
        });
    },
    saveYearlyRelationship() {
      this.loadingYearlyRelationshipModal = true;

      axios
        .post('https://api.destinycards.com/v1/reportadmin/yearlyrelationshipupdate', this.rpt)
        .then(response => {
            if (response.status === 200) {
              this.$root.$emit("bv::hide::modal", "yearlyrelationshipedit");

              this.$swal.fire('Record Saved', 'Report Saved Successfully.<br /><br /><a href="https://www.destinyreports.com/m/yearlyrelationship.html?no=' + this.rpt.number + '&s=' + this.rpt.orderid + '" target="_blank" style="color: royalblue">View Report</a>', 'success');
              this.loadingYearlyRelationshipModal = false;
            }
        })
        .catch(error => {
          this.loadingYearlyRelationshipModal = false;
          this.$swal.fire('Error', 'There was an error saving. Please hit F12 and copy/paste the error message in the console and email support.', 'error');
          console.log("ERROR - Copy/Paste Info Below");
          console.log(error);
        });
    },
    saveMoney() {
      this.loadingMoneyModal = true;

      axios
        .post('https://api.destinycards.com/v1/reportadmin/moneyupdate', this.rpt)
        .then(response => {
            if (response.status === 200) {
              this.$root.$emit("bv::hide::modal", "moneyedit");

              this.$swal.fire('Record Saved', 'Report Saved Successfully.<br /><br /><a href="https://www.destinyreports.com/m/findmoney.html?no=' + this.rpt.number + '&s=' + this.rpt.orderid + '" target="_blank" style="color: royalblue">View Report</a>', 'success');
              this.loadingMoneyModal = false;
            }
        })
        .catch(error => {
          this.loadingMoneyModal = false;
          this.$swal.fire('Error', 'There was an error saving. Please hit F12 and copy/paste the error message in the console and email support.', 'error');
          console.log("ERROR - Copy/Paste Info Below");
          console.log(error);
        });
    },
    saveSuccess() {
      this.loadingSuccessModal = true;

      axios
        .post('https://api.destinycards.com/v1/reportadmin/successupdate', this.rpt)
        .then(response => {
            if (response.status === 200) {
              this.$root.$emit("bv::hide::modal", "successedit");

              this.$swal.fire('Record Saved', 'Report Saved Successfully.<br /><br /><a href="https://www.destinyreports.com/m/findsuccess.html?no=' + this.rpt.number + '&s=' + this.rpt.orderid + '" target="_blank" style="color: royalblue">View Report</a>', 'success');
              this.loadingSuccessModal = false;
            }
        })
        .catch(error => {
          this.loadingSuccessModal = false;
          this.$swal.fire('Error', 'There was an error saving. Please hit F12 and copy/paste the error message in the console and email support.', 'error');
          console.log("ERROR - Copy/Paste Info Below");
          console.log(error);
        });
    },
    saveLove() {
      this.loadingLoveModal = true;

      axios
        .post('https://api.destinycards.com/v1/reportadmin/loveupdate', this.rpt)
        .then(response => {
            if (response.status === 200) {
              this.$root.$emit("bv::hide::modal", "loveedit");

              this.$swal.fire('Record Saved', 'Report Saved Successfully.<br /><br /><a href="https://www.destinyreports.com/m/findlove.html?no=' + this.rpt.number + '&s=' + this.rpt.orderid + '" target="_blank" style="color: royalblue">View Report</a>', 'success');
              this.loadingSuccessModal = false;
            }
        })
        .catch(error => {
          this.loadingLoveModal = false;
          this.$swal.fire('Error', 'There was an error saving. Please hit F12 and copy/paste the error message in the console and email support.', 'error');
          console.log("ERROR - Copy/Paste Info Below");
          console.log(error);
        });
    },
    editYearly(rec) {

      //Existing Report Meta Data
      this.rec = rec;
      this.rec.mailto_user_email = "mailto:" + this.rec.user_email;
      this.rec.createdate_formatted = moment(rec.createdate, 'YYYYMMDD').format('YYYY-MM-DD');

      //Load Specific Yearly Report Data
      this.fetchYearlyReport(rec.orderno);
    },
    editRelationship(rec) {

      //Existing Report Meta Data
      this.rec = rec;
      this.rec.mailto_user_email = "mailto:" + this.rec.user_email;
      this.rec.createdate_formatted = moment(rec.createdate, 'YYYYMMDD').format('YYYY-MM-DD');

      //Load Specific Yearly Report Data
      this.fetchRelationshipReport(rec.orderno);
    },
    editYearlyRelationship(rec) {

      //Existing Report Meta Data
      this.rec = rec;
      this.rec.mailto_user_email = "mailto:" + this.rec.user_email;
      this.rec.createdate_formatted = moment(rec.createdate, 'YYYYMMDD').format('YYYY-MM-DD');

      //Load Specific Yearly Report Data
      this.fetchYearlyRelationshipReport(rec.orderno);
    },
    editMoney(rec) {

      //Existing Report Meta Data
      this.rec = rec;
      this.rec.mailto_user_email = "mailto:" + this.rec.user_email;
      this.rec.createdate_formatted = moment(rec.createdate, 'YYYYMMDD').format('YYYY-MM-DD');

      //Load Specific Yearly Report Data
      this.fetchMoneyReport(rec.orderno);
    },
    editSuccess(rec) {

      //Existing Report Meta Data
      this.rec = rec;
      this.rec.mailto_user_email = "mailto:" + this.rec.user_email;
      this.rec.createdate_formatted = moment(rec.createdate, 'YYYYMMDD').format('YYYY-MM-DD');

      //Load Specific Yearly Report Data
      this.fetchSuccessReport(rec.orderno);
    },
    editLove(rec) {

      //Existing Report Meta Data
      this.rec = rec;
      this.rec.mailto_user_email = "mailto:" + this.rec.user_email;
      this.rec.createdate_formatted = moment(rec.createdate, 'YYYYMMDD').format('YYYY-MM-DD');

      //Load Specific Yearly Report Data
      this.fetchLoveReport(rec.orderno);
    },
    onRowClick(params) {
      switch (params.row.productid)
      {
        case 171: this.rpt = 0;
                  this.loadingYearlyModal = true;
                  this.$root.$emit("bv::show::modal", "yearlyedit");
                  this.editYearly(params.row); break;
        case 176: this.rpt = 0;
                  this.loadingRelationshipModal = true;
                  this.$root.$emit("bv::show::modal", "relationshipedit");
                  this.editRelationship(params.row); break;
        case 180: this.rpt = 0;
                  this.loadingYearlyRelationshipModal = true;
                  this.$root.$emit("bv::show::modal", "yearlyrelationshipedit");
                  this.editYearlyRelationship(params.row); break;
        case 181: this.rpt = 0;
                  this.loadingMoneyModal = true;
                  this.$root.$emit("bv::show::modal", "moneyedit");
                  this.editMoney(params.row); break;
        case 182: this.rpt = 0;
                  this.loadingSuccessModal = true;
                  this.$root.$emit("bv::show::modal", "successedit");
                  this.editSuccess(params.row); break;
        case 183: this.rpt = 0;
                  this.loadingLoveModal = true;
                  this.$root.$emit("bv::show::modal", "loveedit");
                  this.editLove(params.row); break;
        default: alert('Can\'t edit this type of report yet. Soon!');
      }
    },
		updateValues(d) {
			var startDate = moment(d.startDate);
			var endDate = moment(d.endDate);
			var gap = endDate.diff(startDate, 'days');
			
			this.dateRange.range.prevStartDate = moment(startDate).subtract('days', gap).format('D MMMM');
			this.dateRange.range.prevEndDate = moment(startDate).subtract('days', 1).format('D MMMM YYYY');
			console.log(d.startDate);
		},
		formatDate(d) {
			var monthsName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
			d = new Date(d);
			d = monthsName[d.getMonth()] + ' ' + d.getDate();
			return d;
		},
    changedYearlyBirthdate()
    {
        let number_birthdate = moment(this.rpt.birthdate).format('YYYYMMDD');
        axios
          .get('https://api.destinycards.com/v1/reportadmin/prcinfo/' + number_birthdate)
          .then(response => {
              let prcs = response.data.data;
              if (prcs !== undefined && prcs !== null)
              {
                if (prcs.length == 2) //Cusp!
                {
                  this.rpt.perssigni1 = prcs[0].bc;
                  this.$swal.fire({
                    title: 'Cusp Date',
                    text: 'Select the sunsign for this person.',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: prcs[0].sunsign,
                    cancelButtonText: prcs[1].sunsign,
                    confirmButtonColor: 'teal',
                    cancelButtonColor: 'teal'
                  }).then((result) => {
                    if (result.isConfirmed)
                    {
                      this.rpt.perssigni1 = prcs[0].bc;
                      this.rpt.perssigni2 = prcs[0].prc;
                      this.rpt.PRCard1 = prcs[0].prc;
                      this.rpt.PRCard2 = prcs[0].prc2;
                    }
                    else
                    {
                      this.rpt.perssigni1 = prcs[1].bc;
                      this.rpt.perssigni2 = prcs[1].prc;
                      this.rpt.PRCard1 = prcs[1].prc;
                      this.rpt.PRCard2 = prcs[1].prc2;
                    }
                  });

                }
                else
                {
                  this.rpt.perssigni1 = prcs[0].bc;
                  this.rpt.perssigni2 = prcs[0].prc;
                  this.rpt.PRCard1 = prcs[0].prc;
                  this.rpt.PRCard2 = prcs[0].prc2;
                }
              }
          })
          .catch(error => {
            console.log(error);
          });

          this.rpt.repstartdate = this.rpt.birthdate.substring(0, this.rpt.birthdate.length-4) + moment().year();
    },
    changedRelationshipBirthdate1() {
      let number_birthdate = moment(this.rpt.birthdate1).format('YYYYMMDD');
        axios
          .get('https://api.destinycards.com/v1/reportadmin/prcinfo/' + number_birthdate)
          .then(response => {
              let prcs = response.data.data;
              this.rpt.planet1 = this.sunPlanet[prcs[0].sunsign];
              if (prcs !== undefined && prcs !== null)
              {
                if (prcs.length == 2) //Cusp!
                {
                  this.$swal.fire({
                    title: 'Cusp Date',
                    text: 'Select the sunsign for this person.',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: prcs[0].sunsign,
                    cancelButtonText: prcs[1].sunsign,
                    confirmButtonColor: 'teal',
                    cancelButtonColor: 'teal'
                  }).then((result) => {
                    if (result.isConfirmed)
                    {
                      this.rpt.planet1 = this.sunPlanet[prcs[0].sunsign];
                    }
                    else
                    {
                      this.rpt.planet1 = this.sunPlanet[prcs[1].sunsign];
                    }
                  });

                }
                else
                {
                  this.rpt.planet1 = this.sunPlanet[prcs[0].sunsign];
                }
              }

          })
          .catch(error => {
            console.log(error);
          });
    },
    changedRelationshipBirthdate2() {
      let number_birthdate = moment(this.rpt.birthdate2).format('YYYYMMDD');
        axios
          .get('https://api.destinycards.com/v1/reportadmin/prcinfo/' + number_birthdate)
          .then(response => {
              let prcs = response.data.data;
              this.rpt.planet2 = this.sunPlanet[prcs[0].sunsign];
              if (prcs !== undefined && prcs !== null)
              {
                if (prcs.length == 2) //Cusp!
                {
                  this.$swal.fire({
                    title: 'Cusp Date',
                    text: 'Select the sunsign for this person.',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: prcs[0].sunsign,
                    cancelButtonText: prcs[1].sunsign,
                    confirmButtonColor: 'teal',
                    cancelButtonColor: 'teal'
                  }).then((result) => {
                    if (result.isConfirmed)
                    {
                      this.rpt.planet2 = this.sunPlanet[prcs[0].sunsign];
                    }
                    else
                    {
                      this.rpt.planet2 = this.sunPlanet[prcs[1].sunsign];
                    }
                  });

                }
                else
                {
                  this.rpt.planet2 = this.sunPlanet[prcs[0].sunsign];
                }
              }

          })
          .catch(error => {
            console.log(error);
          });
    },
    changedRelationshipBirthdate3() {
      let number_birthdate = moment(this.rpt.birthdate3).format('YYYYMMDD');
        axios
          .get('https://api.destinycards.com/v1/reportadmin/prcinfo/' + number_birthdate)
          .then(response => {
              let prcs = response.data.data;
              this.rpt.planet3 = this.sunPlanet[prcs[0].sunsign];
              if (prcs !== undefined && prcs !== null)
              {
                if (prcs.length == 2) //Cusp!
                {
                  this.$swal.fire({
                    title: 'Cusp Date',
                    text: 'Select the sunsign for this person.',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: prcs[0].sunsign,
                    cancelButtonText: prcs[1].sunsign,
                    confirmButtonColor: 'teal',
                    cancelButtonColor: 'teal'
                  }).then((result) => {
                    if (result.isConfirmed)
                    {
                      this.rpt.planet3 = this.sunPlanet[prcs[0].sunsign];
                    }
                    else
                    {
                      this.rpt.planet3 = this.sunPlanet[prcs[1].sunsign];
                    }
                  });

                }
                else
                {
                  this.rpt.planet3 = this.sunPlanet[prcs[0].sunsign];
                }
              }

          })
          .catch(error => {
            console.log(error);
          });
    },
    changedRelationshipBirthdate4() {
      let number_birthdate = moment(this.rpt.birthdate4).format('YYYYMMDD');
        axios
          .get('https://api.destinycards.com/v1/reportadmin/prcinfo/' + number_birthdate)
          .then(response => {
              let prcs = response.data.data;
              this.rpt.planet4 = this.sunPlanet[prcs[0].sunsign];
              if (prcs !== undefined && prcs !== null)
              {
                if (prcs.length == 2) //Cusp!
                {
                  this.$swal.fire({
                    title: 'Cusp Date',
                    text: 'Select the sunsign for this person.',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: prcs[0].sunsign,
                    cancelButtonText: prcs[1].sunsign,
                    confirmButtonColor: 'teal',
                    cancelButtonColor: 'teal'
                  }).then((result) => {
                    if (result.isConfirmed)
                    {
                      this.rpt.planet4 = this.sunPlanet[prcs[0].sunsign];
                    }
                    else
                    {
                      this.rpt.planet4 = this.sunPlanet[prcs[1].sunsign];
                    }
                  });

                }
                else
                {
                  this.rpt.planet4 = this.sunPlanet[prcs[0].sunsign];
                }
              }

          })
          .catch(error => {
            console.log(error);
          });
    },
    changedMoneySuccessBirthdate() {
      let number_birthdate = moment(this.rpt.birthdate).format('YYYYMMDD');
        axios
          .get('https://api.destinycards.com/v1/reportadmin/prcinfo/' + number_birthdate)
          .then(response => {
              let prcs = response.data.data;
              this.rpt.sunsign = prcs[0].sunsign;
              this.rpt.startdate = this.rpt.birthdate.substring(0, this.rpt.birthdate.length-4) + moment().year();
              if (prcs !== undefined && prcs !== null)
              {
                if (prcs.length == 2) //Cusp!
                {
                  this.$swal.fire({
                    title: 'Cusp Date',
                    text: 'Select the sunsign for this person.',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: prcs[0].sunsign,
                    cancelButtonText: prcs[1].sunsign,
                    confirmButtonColor: 'teal',
                    cancelButtonColor: 'teal'
                  }).then((result) => {
                    if (result.isConfirmed)
                    {
                      this.rpt.sunsign = prcs[0].sunsign;
                    }
                    else
                    {
                      this.rpt.sunsign = prcs[1].sunsign;
                    }
                  });

                }
                else
                {
                  this.rpt.sunsign = prcs[0].sunsign;
                }
              }

          })
          .catch(error => {
            console.log(error);
          });
    },
    changedReportTypeFilter() {
      alert('ha');
    }
	},
	filters: {
		date: function(value) {
			if (value) {
				return moment(String(value)).format('D MMMM YYYY')
			}
		}
	},
  mounted: function() {
    let username = this.cookies.get('username');
    let authenticated = this.cookies.get("authenticated");
    if (username === null || authenticated === null)
    {
      this.$router.push('/user/login-v3');
    }
    else {
      const crypto = require('crypto');
      const secret = 'GASEWkjshga@asdjfhasdfAA!fcaf@gdh#asdA';
      const hash = crypto.createHmac('sha256', secret)
          .update(authenticated)
          .digest('hex');
      if (username !== 'admin' || hash !== 'b8d32bd79ea384bb101f69e0935ee9c87be516c6642e39a479bf417b16354b2e') {
        this.$router.push('/user/login-v3');
      } else {
        this.fetchReportData();
      }
    }
  }
}
</script>